import { render, staticRenderFns } from "./ContactLink.vue?vue&type=template&id=2e568095"
import script from "./ContactLink.vue?vue&type=script&lang=js"
export * from "./ContactLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports